const firebaseConfig = {
    apiKey: "AIzaSyDCN5VNHwlSDeVbxZleTyPJHzuBsFhuH4c",
    authDomain: "eticket-ff180.firebaseapp.com",
    projectId: "eticket-ff180",
    storageBucket: "eticket-ff180.appspot.com",
    messagingSenderId: "463532533493",
    appId: "1:463532533493:web:5951899172bb351a4847bc"
};

export default firebaseConfig;